import { connect } from 'react-redux'
import RssFeedDetailView  from './RssFeedDetailView.jsx'

const mapStateToProps = (state, ownProps) => {
  return {
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
  }
}

const RssFeedDetailContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(RssFeedDetailView)

export default RssFeedDetailContainer;